import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Layout from "../components/Layout";

import Footer from "../components/Footer";
import Header from "../components/Header";
import IndexVid from "../assets/images/IndexVid.webp";
import HomePageVideo from "../assets/video/downtown.mp4";
import section1Img from "../assets/images/section1.jpg";
import section2Img from "../assets/images/section2.jpg";
import CarouselSection from "../components/carousel";

const IndexPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 2300,
      once: true,
    });
  }, []);
  return (
    <Layout>
      <Header />
      <header className="masthead">
        <div className="overlay" />
        <video
          autoPlay
          muted
          loop
          playsInline="true"
          poster={IndexVid}
          disablePictureInPicture="true"
        >
          <source src={HomePageVideo} type="video/mp4" />
        </video>
        <div className="container d-flex h-100 align-items-center justify-content-center">
          <div className="headerCard text-center">
            <h1 className="m-0">more people...</h1>
            <h1 className="m-0">more transactions...</h1>
            <h1 className="m-0">more trash...</h1>
            <a href="/apply/#agent" className="btn btn-primary headerButton">
              be an agent
            </a>
          </div>
        </div>
      </header>

      <section id="projects" className="projects-section projects-section-1">
        <div className="row align-items-center no-gutters mb-4 mb-lg-5">
          <div className="col-xl-7 col-lg-7" data-aos="fade-right">
            <div className="featured-text text-center text-lg-left">
              <p className="text-black mb-0">
                the population explosion and increased carbon footprint has
                resulted in an overwhelming surge in waste. households are in
                dire need of a supplemental garbage and recycling collection
                service to complement existing city services in order to keep up
                with the new pace of global consumption.
              </p>
              <a href="/apply/#agent">
                <button className="btn btn-success">Agent app</button>
              </a>
            </div>
          </div>
          <div className="col-xl-5 col-lg-5" data-aos="fade-left">
            <img
              className="img-fluid mb-3 mb-lg-0 section1Img"
              src={section1Img}
              alt=""
            />
          </div>
        </div>
      </section>

      <section id="projects" className="projects-section projects-section-2">
        <div className="row align-items-center no-gutters mb-4 mb-lg-5">
          <div className="col-xl-5 col-lg-5" data-aos="fade-right">
            <img
              className="img-fluid mb-3 mb-lg-0 section2Img"
              src={section2Img}
              alt=""
            />
          </div>
          <div className="col-xl-7 col-lg-7" data-aos="fade-left">
            <div className="featured-text text-center text-lg-left">
              <p className="text-black mb-0">
                introducing PckitUp, the world’s first residential on-demand
                garbage and recycling collection service. PckitUp empowers
                customers with the opportunity to dispose of excessive waste
                with a few clicks on their smart phone. the PckitUp technology
                platform connects customers with nearby PckitUp agents for a
                nominal fee. no contracts, no waiting, and no hassles. we are
                extremely excited to provide this service as a solution to the
                world’s population and waste surge. join us in our quest to
                combat excessive waste and optimize recycling collection.
              </p>
              <a href="/apply/#customer">
                <button className="btn btn-success">Customer app</button>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="review-section" data-aos="fade-up">
        <h3 className="text-center mb-lg-5 font-weight-bold">reviews</h3>
        <CarouselSection type="index" />
      </section>

      <Footer />
    </Layout>
  );
};

export default IndexPage;
